import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { IconLogout } from '@tabler/icons-react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { LigningIcon } from './LigningIcon';
import { LogoutIcon } from './LogoutIcon';
import { Button } from 'react-bootstrap';
import MainLogo from './MainLogo.png';

function DashboardHeader(props) {

    return (
        <Navbar expand="sm" className="bg-black">
            <Container fluid>
                <div className='logo-text'>
                <img src={MainLogo} style={{ height: '28px'}} alt="logo"/>
                <LigningIcon height={48} width={48} />

                </div>
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <div className='email-container'>
                        <div style={{ display: "inline-block" }}>{props.email}</div>
                        <div style={{ display: "inline-block"}} onClick={() => {
                            props.logout();
                        }}>
                            <OverlayTrigger placement="bottom" overlay={<Tooltip>Logout</Tooltip>}>
                                <Button style={{ backgroundColor: 'rgba(52, 82, 244, 0.2)', marginLeft: '15px', border:'none'}}>
                                    <LogoutIcon style={{ cursor: 'pointer' }} />
                                </Button>
                            </OverlayTrigger>
                        </div>
                        </div>
                    </Navbar.Text>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default DashboardHeader;